// src/components/ToggleSwitch.js
import React from 'react';

export default function ToggleSwitch({ isToggled, onToggle, disabled }) {
  return (
    <label className="toggle-switch">
      <input type="checkbox" checked={isToggled} onChange={onToggle} disabled={disabled} />
      <span className="slider"></span>
    </label>
  );
}